export default `varying vec2 a;void main(){a=uv;vec4 b=modelViewMatrix*vec4(position,1);gl_Position=projectionMatrix*b;}`;